var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.data.length > 0)?_c('div',[_c('ScrollableBanner',{attrs:{"title":_vm.$t('Team of professionals'),"items":_vm.data,"nItems":""},scopedSlots:_vm._u([{key:"item",fn:function({ key: index, value: team }){return [_c('TeamCard',{attrs:{"team":team,"index":index}})]}}],null,false,2244449143)})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }